import {
    DELETE_SKILLS_SUCCESS,
    DELETE_SKILLS_REQUEST,
    DELETE_SKILLS_FAIL
} from "../constants/AuthConstant";

const initialState = {
    result: null,
    loading: null,
    error: null
};

const DeleteSkillsReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_SKILLS_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };

        case DELETE_SKILLS_SUCCESS:
            return {
                ...state,
                result: action.result.data,
                loading: action.payload,
            };

        case DELETE_SKILLS_FAIL:
            return {
                ...state,
                error: action.error,
                loading: action.payload,
                msg: action.msg,
            };

        default:
            return state;
    }
};

export default DeleteSkillsReducer;